import "@/index.css";
import "@/i18n/i18n";

import React from "react";
import ReactDOM from "react-dom/client";

import App from "@/App";

try {
  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} catch {
  // Silent fail
}
